import React from 'react'
import { Button,message } from 'antd'
import { withTranslation } from 'react-i18next'
import common from '../../asserts/js/common'
import { 
  checkOnImg,
  checkOffImg
} from '../../asserts/imgs/login/index'
import { nextImg, remeberOffImg, remeberOnImg } from '@/asserts/imgs/common/index';
import Appstyles from '../../App.less'
import styles from './Apply.less'

class Apply extends React.Component{
  constructor(props) {
    super(props);

    const now = new Date();
    const formattedDate = `${now.getFullYear()}/${String(now.getMonth() + 1).padStart(2, '0')}/${String(now.getDate()).padStart(2, '0')}`;

    this.state = {
      currentDate: formattedDate,
      isLoading:false,
      minheight1:800,
      agreeData:[
        {title:'本人同意遵守紐約交易所(NYSE)相關規範',value:true,checked:true,type:'yes'},
        // {title:'本人不同意',value:false,checked:false,type:'no'},
      ],
    }
  }
  pdfReadClick(){
    this.props.callbackPDFOpen()
  }
  //送出申請
  sendClick(){
    this.setState({
      isLoading: true
    })
    if (common.enableWebca) {
      //SIGN WITH CERT WHEN CLICKED SIGN BUTTON
      const userid = this.props.uid || sessionStorage.getItem('uid');
      const certFilter = "//S_CN=" + userid + "//";
      const signContent = "SIGNEAGREEMENT";

      if (window.inAppDetector.isInApp()) {
        //IF IT IS IN WEBVIEW, SIGN WITH CERT IN APP
        window.mtklib.sign({
          "idno": userid,
          "tosign": signContent,
          "method": "P1",
          "cb": (cbobj) => {
            if (cbobj.code == "0") {
              fetch(common.getHttpAgree + 'signeagreement', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json,text/plain,*/*',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  token: window.sessionStorage.getItem('token'),
                  // name: nameValue,
                  // job: jobValue,
                  sign_type: "pkcs1",
                  signature: cbobj.signed,
                  src: signContent,
                  sn: cbobj.casno,
                  agreement_1: true,
                  agreement_2: true,
                })
              })
                .then(res => res.json())
                .then(res => {
                  if (res['status'] == 0) {
                    this.props.callbackSend()
                  } else {
                    //获取失败
                    this.setState({
                      isLoading: false
                    })
                    message.warning({
                      content: res['message']
                    })
                  }
                })
            } else {
              //获取失败
              this.setState({
                isLoading: false
              })
              message.warning({
                content: cbobj.code + " " + cbobj.desc
              })
            }
          }
        })
      } else {
        //執行PKCS7簽章
        window.twcaLib.SignPkcs7(signContent, 0x0000, (code, msg, token, data) => {
          if (code === 0 && data) {
            var certData = JSON.parse(data);

            fetch(common.getHttpAgree + 'signeagreement', {
              method: 'POST',
              headers: {
                'Accept': 'application/json,text/plain,*/*',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                token: window.sessionStorage.getItem('token'),
                // name: nameValue,
                // job: jobValue,
                signature: certData.signature,
                data: signContent,
                subject: certData.subdn,
                agreement_1: true,
                agreement_2: true,
              })
            })
              .then(res => res.json())
              .then(res => {
                if (res['status'] == 0) {
                  this.props.callbackSend()
                } else {
                  //获取失败
                  this.setState({
                    isLoading: false
                  })
                  message.warning({
                    content: res['message']
                  })
                }
              })
          } else if (code === 5067 || code === "5067") {
            //憑證挑選
            window.twcaLib.SelectSignerFubon(userid, certFilter, "", "", "", 0x04 | 0x08, 0, null, (code, msg, token, data) => {
              if (code === 0) {
                //執行PKCS7簽章
                window.twcaLib.SignPkcs7(signContent, 0x0000, (code, msg, token, data) => {
                  if (code === 0 && data) {
                    var certData = JSON.parse(data);

                    fetch(common.getHttpAgree + 'signeagreement', {
                      method: 'POST',
                      headers: {
                        'Accept': 'application/json,text/plain,*/*',
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                        token: window.sessionStorage.getItem('token'),
                        // name: nameValue,
                        // job: jobValue,
                        signature: certData.signature,
                        data: signContent,
                        subject: certData.subdn,
                        agreement_1: true,
                        agreement_2: true,
                      })
                    })
                      .then(res => res.json())
                      .then(res => {
                        if (res['status'] == 0) {
                          this.props.callbackSend()
                        } else {
                          //获取失败
                          this.setState({
                            isLoading: false
                          })
                          message.warning({
                            content: res['message']
                          })
                        }
                      })
                  } else {
                    this.setState({
                      isLoading: false
                    })
                    message.warning({
                      content: code + " " + msg
                    })
                  }
                });
              } else {
                this.setState({
                  isLoading: false
                })
                message.warning({
                  content: code + " " + msg
                })
              }
            });
          } else {
            this.setState({
              isLoading: false
            })
            message.warning({
              content: code + " " + msg
            })
          }
        });
      }
    } else {
      const token = window.sessionStorage.getItem('token')
      fetch(common.getHttpAgree + 'signeagreement', {
        method: 'POST',
        headers: {
          'Accept': 'application/json,text/plain,*/*',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: token,
          // name: nameValue,
          // job: jobValue,
          signature: "dev",
          data: "dev",
          subject: "dev",
          agreement_1: true,
          agreement_2: true,
        })
      })
        .then(res => res.json())
        .then(res => {
          if (res['status'] == 0) {
            this.props.callbackSend()
          } else {
            //获取失败
            this.setState({
              isLoading: false
            })
            message.warning({
              content: res['message']
            })
          }
        })
    }
  }
  render(){
    const {bodyW,mobilebodyW,bodyH} = this.props
    const {agreeData,isLoading,minheight1,currentDate}=this.state
    return (
      <div 
        className={[
          styles.trade_apply_con,
          styles.applyCon,
          Appstyles.overflowYScroll
        ].join(' ')}
        style={{
          width:bodyW>mobilebodyW?525:'100%',
          height:bodyW>mobilebodyW?bodyH<=minheight1?'80%':700:'100%'
        }}
      >
        <div className={[styles.trade_apply_title,styles.border_bottom_D6D6D6,styles.flex_row_center].join(' ')}>聲明條款</div>
        <div style={{padding:20}}>
          <div className={styles.checkCon}>
            <div className={[Appstyles.flex_between,styles.trade_apply_down,Appstyles.fw500,styles.border_bottom_D6D6D6].join(' ')}>
              <span style={{cursor:'pointer'}} onClick={this.pdfReadClick.bind(this)}>ICE（NYSE）交易所</span>
              <div className={[styles.flex_row_center,Appstyles.fw700].join(' ')} style={{cursor:'pointer'}} onClick={()=>this.props.onDownFileClick()}>
                <span>下載</span>
                <img src={nextImg} className={Appstyles.img24} alt='next' />
              </div>
            </div>
            <div className={[Appstyles.flex_row,Appstyles.fw500].join(' ')}>
              {agreeData.length > 0 &&
                agreeData.map((item, index) => (
                  <div key={index} className={styles.flex_row_center}>
                    <img src={item['checked']?checkOnImg:checkOffImg} className={Appstyles.img24} alt='checked' />
                    <span>{item['title']}</span>
                  </div>
                ))
              }
            </div>
          </div>
          <div className={[styles.flex_row_center,Appstyles.fw700].join(' ')} style={{justifyContent:'flex-end',marginTop:60}}>日期：{currentDate}</div>
          <div className={[styles.trade_place_button,styles.trade_apply_btn].join(' ')}>
            <Button 
              type='default' 
              loading={isLoading} 
              className={styles.Sended} 
              onClick={this.sendClick.bind(this)}
            >
              送出
            </Button>
          </div>
        </div>
      </div>
  )}
}
export default withTranslation()(Apply)